import React from 'react';
import {
    List,
    DateField,
    TextField,
    DatagridConfigurable,
    FunctionField,
    useGetList,
    Filter,
    AutocompleteInput,
    DateInput,
    ReferenceInput, ArrayField, WithListContext
} from 'react-admin';

const AppointmentFilter = (props) => {

    const {data: allTypes, isLoading} =
        useGetList('admin/medical/appointment-types');
    const {data: allProviders, isProvidersLoading} =
        useGetList('admin/providers');
    return <Filter {...props}>
        <DateInput source="appointment_date_after" name="minDate" label="Appointments After" />
        <DateInput source="appointment_date_before" name="maxDate" label="Appointments Before" />
        <AutocompleteInput
            label="Appointment type"
            name="appointment_type_id"
            source="appointmentType"
            choices={allTypes}
            optionText={type => `${type.category} ${type.name}`}
            isLoading={isLoading}
            sx={{minWidth: 300}}
        />
        <AutocompleteInput
            label="Provider"
            name="provider_id"
            source="providers"
            choices={allProviders}
            optionText={provider => `${provider.user?.first_name} ${provider.user?.last_name}`}
            isLoading={isProvidersLoading}
            sx={{minWidth: 300}}
        />
        <ReferenceInput reference="admin/user" source="user_id" label="User" name="user_id" sx={{minWidth: 300}}/>
    </Filter>
}

const AcuityFormField = (field) => {
    if (!field || !field.values || !field.values[0].value) return;
    const fieldValue = field.values[0];
    switch (fieldValue.name) {
        case 'AthenaAppointmentID': return <li key={fieldValue.id}>Athena {fieldValue.value}</li>
        case 'GennevAppointmentID': return <li key={fieldValue.id}>Appointment {fieldValue.value}</li>
        case 'UserId': return <li key={fieldValue.id}>User {fieldValue.value}</li>
    }
}

export const AcuityAppointmentList = () => {
    return (
        <List title="Acuity Appointments" filters={<AppointmentFilter />}>
            <DatagridConfigurable rowClick={false}>
                <TextField source="id" />
                <DateField source="datetime" showTime={true}/>
                <FunctionField label="Type"
                    source="type"
                    render={app => `${app.category} ${app.type}`}
                />
                <FunctionField label="User"
                               source="userId"
                               render={app => `${app.firstName} ${app.lastName}`}
                />
                <ArrayField source="forms">
                    <WithListContext render={({ data }) => (
                        <ul>
                            {data?.map(field => AcuityFormField(field))}
                        </ul>
                    )} />
                </ArrayField>
                <TextField source="calendar" label="Provider"/>
                <DateField source="datetimeCreated" label="Created"/>
            </DatagridConfigurable>
        </List>
    );
};

